import { render, staticRenderFns } from "./CambiarTalla.vue?vue&type=template&id=c16d706c"
import script from "./CambiarTalla.vue?vue&type=script&setup=true&lang=js"
export * from "./CambiarTalla.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports